import React from 'react'

export default function HTMLTotalTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                var font = props.properties.total?.font || { fontFamily: 'Inter', fontSize: 10, color: '#000000' }
                dStyle.color = dStyle.color || props.properties.prop.fontColor;
                dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";
                dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
                dStyle.zIndex = 2;

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={Object.assign(dStyle, font)}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderVatSummary = () => {
        if (props.properties?.total?.VatSummary &&
            Object.keys(props.properties.total.VatSummary).length > 0) {
            var data = props.properties.total.VatSummary;
            var dStyle = Object.assign({}, data.style || {});
            dStyle.color = dStyle.color || props.properties.prop.fontColor;
            dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";
            dStyle.zIndex = 2;

            const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || 'vat-summary');

            return (
                <div
                    key={data.id || 'vat-summary'}
                    style={dStyle}
                    id={data.id}
                    data-element={data.name || 'VatSummary'}
                    data-section="VatSummary"
                    data-path="elements"
                    data-index={dataIndex}
                >
                    {data.text || ''}
                </div>
            );
        }
        return null;
    };

    const renderShapes = () => {
        if (!props.properties.total.shapes) return null;

        return Object.keys(props.properties.total.shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties.total.shapes[key];
                if (!prop) return null;

                var borderColor = props.properties.total.shapes.border?.color || '#333333FF';
                var borderSize = props.properties.total.shapes.border?.size || 1;
                var bgColor = props.properties.total.shapes.border?.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign({ minWidth: '32px', minHeight: '16px' }, prop.style || {});
                dStyle.border = `${borderSize}px solid ${borderColor}`;
                dStyle.background = bgColor;
                dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) : 32;
                dStyle.zIndex = 1;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={"total"}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{
                height: props.properties.prop.orientation === "landscape"
                    ? props.heights.total * 0.01 * pageSettings[props.properties.prop.paperSize]?.width
                    : props.heights.total * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                position: 'absolute',
                backgroundColor: props.properties.total.background.showColor
                    ? props.properties.total.background.color
                    : "transparent",
            }}>
                <div>
                    {renderElements("total")}
                    {renderVatSummary()}
                    {renderShapes()}
                </div>
            </div>
        </div>
    );
}